import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Lightbox } from '../elements-image/lightbox';
import { ListingImage } from '../elements-image/listing-image';
import { FormattedMessage } from 'react-intl';

const AttendeeImage = ({
  key,
  index,
  className,
  allImages,
  booking,
  imageExternalId
}) => {
  return (
    <Lightbox allImages={allImages} key={key} index={index} hideFavButton hideBookingBtn booking={booking}>
      <ListingImage
        imgId={imageExternalId}
        ratio={1.689}
        widths={[512]}
        defaultWidth={768}
        defaultHeight={454}
        alt="Peerspace"
        sizes="50vw"
        style={`${className} small-padding width-100`}
      />
    </Lightbox>
  );
};

class AttendeePhotoBlock extends Component {
  render () {
    const booking = _.get(this.props, 'booking.booking');
    const allImages = _.get(booking, 'listing.images');
    const heroImage = _.head(allImages);
    const topImages = _.take(_.drop(allImages), 3);
    const bottomImages = _.take(_.drop(allImages, 4), 3);

    return (
      <div className="AttendeePhotoBlock flex column">
        <div className="photos flex">
          <AttendeeImage
            key={0}
            index={0}
            imageExternalId={heroImage.external_id}
            className="hero-image"
            allImages={allImages}
            booking={booking}
          />

          <div className="flex column space-between">
            <div className="flex row" data-testing-id="attendee-images-top-row">
              {
                _.map(topImages, (image, i) => {
                  return (
                    <AttendeeImage
                      key={i + 1}
                      index={i + 1}
                      imageExternalId={image.external_id}
                      className="listing-image"
                      allImages={allImages}
                      booking={booking}
                    />
                  );
                })
              }
            </div>

            <div className="flex row" data-testing-id="attendee-images-bottom-row">
              {
                _.map(bottomImages, (image, i) => {
                  return (
                    <AttendeeImage
                      key={i + 4}
                      index={i + 4}
                      imageExternalId={image.external_id}
                      className="listing-image"
                      allImages={allImages}
                      booking={booking}
                    />
                  );
                })
              }
            </div>
          </div>
        </div>

        <Lightbox allImages={allImages} index={0} hideFavButton hideBookingBtn booking={booking}>
          <div className="margin-lg-top">
            <FormattedMessage id='invite.attendee_photo_block.see_all_pictures' defaultMessage='See all pictures' />
          </div>
        </Lightbox>
      </div>
    );
  }
}

AttendeePhotoBlock.propTypes = {
  booking: PropTypes.object
};

function mapStateToProps (state) {
  const { booking } = state;

  return {
    booking
  };
}

export default connect(mapStateToProps)(AttendeePhotoBlock);
